import * as React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';

import Router from "./routes";
import {Splash} from "./pages";
import {ToastContainer} from "react-toastify";


function App() {
    const isProduction = process.env.NODE_ENV === 'production';

    return (
        <CacheBuster
            currentVersion={packageInfo.version}
            isEnabled={isProduction} //If false, the library is disabled.
            isVerboseMode={false} //If true, the library writes verbose logs to console.
            loadingComponent={<Splash/>} //If not pass, nothing appears at the time of new version check.
        >
            <div className="App">
                <ToastContainer rtl={true}/>
                <Router/>
            </div>
        </CacheBuster>
    );
}

export default App;
